























import { Vue, Component, Prop } from 'vue-property-decorator'
import { initSocket, destroySocket, getSocket } from '@/socket.io'
import { MessageDetail } from '@/types/Message'

@Component
export default class Messages extends Vue {
  // @Prop({ required: true }) getMessageFunc!: Function
  @Prop({ default: '/' }) socketUrl!: string
  private messageList: MessageDetail[] = []

  private get unreadMessages () {
    return this.messageList.filter(m => m.status === 'unread')
  }

  /**
   * 查看消息详情
   * @param msgDetail 消息详情
   */
  private checkMessageDetail (msgDetail: MessageDetail) {
    this.$emit('checkMessageDetail', msgDetail)
  }

  /**
   * 点击通知按钮关闭菜单的时候把消息标记为已读
   * @param isExpanded 是否展开菜单
   */
  private async updateMessageStatus (isExpanded: boolean) {
    if (isExpanded || this.unreadMessages.length === 0) return
    this.$emit('updateMessageStatus', this.unreadMessages)
  }

  /**
   * 监听 websocket 消息, 更新未读消息
   */
  private addMessageListener () {
    const socket = getSocket()
    if (!socket) return
    socket.on('msg_resp', (data: MessageDetail) => {
      if (this.messageList.find(m => m.id === data.id)) return
      this.messageList.unshift(data)
    })
  }

  /**
   * 获取消息列表
   * @private
   */
  private async getMessages () {
    try {
      // this.messageList = await this.getMessageFunc()
    } catch (e) {
      console.warn(e)
    }
  }

  private async mounted () {
    await this.getMessages()
    // 判断之前先来一次接口请求, 这样就可以更新登录状态了
    // await getUserInfo(null).start()
    if (this.$store.state.isLogin) {
      initSocket(this.socketUrl)
    }
    this.addMessageListener()
  }

  private destroyed () {
    destroySocket()
  }
}
